import React from "react";
import { Box, Card, CardContent, Typography } from "@mui/material";
import AuditStatsReport from "./AuditStatsReport/AuditStatsReport";
import ManagementActionReport from "./ManagementActionReport/ManagementActionReport";

const Report = () => {
  return (
    <Box>
      <Card>
        <CardContent>
          {/* Header Title */}
          <Typography
            variant="h6"
            sx={{
              color: "primary.main",
              fontWeight: 700,
              py: 1.5,
              mb: 2,
            }}
          >
            Audit Stats Report
          </Typography>

          {/* Report Sections */}
          <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            <AuditStatsReport />
            <ManagementActionReport />
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

export default Report;